import { IOpenIdRedirect } from '@goparrot/dashboard-gateway-sdk';
import { squareConnectSsoFacade } from '../facades';

export const squareSsoConnectRedirect = (): Promise<IOpenIdRedirect> => squareConnectSsoFacade.redirect();
